import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import Select from 'react-select'
import moment from "moment-timezone";

export default function UtmGroupItemEdit() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let utmGroupItemId = decode.id;
    let utmGroupId = decode.utmGroupId;
    let utmGroupTitle = decode.utmGroupTitle;

    let backPath = '/utmGroupItem/' + Utils.encodeItem({id: utmGroupId, utmGroupTitle: utmGroupTitle});

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [group, setGroup] = React.useState('');
    let [templateSource, setTemplateSource] = React.useState('');
    let [utm, setUtm] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [itemSelected, setItemSelected] = React.useState('');
    let [userAgency, setUserAgency] = React.useState(null);

    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {

            try {
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                refName.current.value = resView.name;
                const resGroup = await Utils.getGroupById(utmGroupId);
                setGroup(resGroup);
                const resSource = await Utils.getTemplateSourceById(resGroup.utmTemplateId);
                const resUtm = await Utils.getUtmByIds(resSource);
                setUtm(resUtm);

                const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
                if(resAgency) {
                    setUserAgency(resAgency[0]);
                }

                let sourceTypeSelectedIds = [];
                if(resView) {
                    let itemSource = resView.itemSource;
                    if(itemSource) {
                        for(let rs of itemSource) {
                            let utmSourceTypeId = rs.utmSourceTypeId;
                            if(utmSourceTypeId) {
                                sourceTypeSelectedIds.push(utmSourceTypeId);
                            }
                        }
                        setItemSelected(sourceTypeSelectedIds);
                    }
                }
                setTemplateSource(resSource);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/utmGroupItem/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: utmGroupItemId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = async () => {
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
        let sourceTypeIds = [];
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                if(st.value) {
                    let utmSourceTypeId = st.value;
                    let utmSourceId = 0;
                    let utmSourceTypeText = null;
                    let inputType = null;

                    let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                    utmSourceId = sourceTypeRow.utmSourceId;
                    utmSourceTypeText = sourceTypeRow.name;

                    sourceTypeIds.push({
                        utmSourceId: utmSourceId,
                        utmSourceTypeId: utmSourceTypeId,
                        utmSourceTypeText: utmSourceTypeText,
                        inputType: inputType
                    });
                }
            }
        }

        let name = refName.current.value; 
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Group Item");
            refName.current.focus();
        }
        else if(sourceTypeIds.length !== selectSourceTypeIds.length) {
            toast.error("กรุณาเลือก UTM ให้ครบถ้วน");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                utmGroupId: utmGroupId,
                                currentName: data.name,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                sourceTypeIds: sourceTypeIds
                            };
                            fetch(Config.url.API_URL +'/api/utmGroupItem/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(backPath, {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Group Item</div>
                    <span className="ms-1">/</span> <span className="text-danger fw-bold">{utmGroupTitle}</span>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Group Item <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                {
                                    utm.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                        utm.map((row, index) => {
                                            let sourceNames = [];
                                            if(templateSource.length > 0) {
                                                for(let rs of templateSource) {
                                                    if(rs.source && rs.utmId === row.id) {
                                                        sourceNames.push(rs.source.name);
                                                    }
                                                }
                                            }
                                            return (
                                                <div key={index} className="border rounded bg-yellow-light p-2 mb-3">
                                                    <div className="d-block fw-bold">utm_{row.name.toLowerCase()} <span className="text-danger">*</span></div>
                                                    <div className="small text-muted">{sourceNames.join('_')}</div>
                                                    {
                                                        templateSource.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                                                            templateSource.map((rs, index2) => {
                                                                if(rs.source && rs.utmId === row.id) {
                                                                    let rsSource = rs.source.sourceType;
                                                                    let inputType = rs.source.inputType;
                                                                    let selected = null;
                                                                    let disabled = false;

                                                                    if(inputType === Utils.API_TYPE_CAMPAIGN_ID
                                                                        || inputType === Utils.API_TYPE_CAMPAIGN_NAME
                                                                        || inputType === Utils.API_TYPE_PROJECT_ID
                                                                        || inputType === Utils.API_TYPE_PROJECT_NAME
                                                                        || inputType === Utils.API_TYPE_PROJECT_SLUG
                                                                        || inputType === Utils.API_TYPE_PROMOTION_SLUG
                                                                        || inputType === Utils.API_TYPE_LINE_OAID
                                                                    ) {
                                                                        disabled = true;
                                                                        rsSource = [];
                                                                    }

                                                                    if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                        disabled = true;
                                                                        rsSource = [];
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                                        //rsSource = contentId;
                                                                        disabled = true;
                                                                        rsSource = [];
                                                                    }
                                                                    else {
                                                                        if(rsSource) {
                                                                            for(let s of rsSource) {
                                                                                if(itemSelected.length && itemSelected.includes(s.id)) {
                                                                                    selected = {id: s.id, name: s.name};
                                                                                }
                                                                            }
                                                                        }
                                                                    }

                                                                    return (
                                                                        <div key={index2} className="ms-2 mt-3">
                                                                            <div className="row mt-2">
                                                                                <div className="col-12 col-sm-4 text-end small">
                                                                                    {rs.source.name} :
                                                                                    {userAgency?.isEncrypt === 1 && rs.source.isEncrypt ? <div><span className="badge bg-secondary small">encrypt</span></div>:''}
                                                                                </div>
                                                                                <div className="col-12 col-sm-8">
                                                                                    <Select
                                                                                        isClearable={true}
                                                                                        name="sourceTypeIds[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        placeholder={rsSource.length ? 'Select...':'...'}
                                                                                        isDisabled={disabled}
                                                                                        defaultValue={selected}
                                                                                        options={rsSource}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            })
                                                    }
                                                </div>
                                            );
                                        })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to={backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 